import _ from 'underscore';
import { parseSync } from '@bingads-webui/safe-json';
import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';

export const getColor = (metricName) => {
  if (metricName === 'Actual') {
    return 'rgba(227, 0, 140, 1)';
  } else if (metricName === 'CTR') {
    return 'rgba(99, 124, 239, 1)';
  } else if (metricName === 'Impressions') {
    return 'rgba(42, 160, 164, 1)';
  }
  return 'gray';
};

export const normalizeData = ({ checkpointResults, i18n, serverContext }) => {
  const result = {};
  _.each(checkpointResults, (checkpointResult) => {
    const { CheckpointDataMap, CheckpointKey } = checkpointResult;
    const { CheckpointDataJsonString } = CheckpointDataMap[0];
    const CheckpointData = parseSync(CheckpointDataJsonString);
    let normalizedData = {};
    if (CheckpointKey === 'LimitedByAutoBidTargetPerf') {
      const { BidPoints } = CheckpointData[0];
      const reversedBidPoints = BidPoints.reverse();
      normalizedData = {
        startDate: i18n.formatDate(new Date(_.first(reversedBidPoints).Date), {
          skeleton: 'yMd',
          timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
        }),
        endDate: i18n.formatDate(new Date(_.last(reversedBidPoints).Date), {
          skeleton: 'yMd',
          timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
        }),
        missedConversions: CheckpointData[0].MissingConversion,
        latestActualTarget: CheckpointData[0].LatestActualTarget,
        latestSuggestTarget: CheckpointData[0].LatestSuggestTarget,
        verticalTarget: CheckpointData[0].VerticalTarget,
        verticalPercentage: CheckpointData[0].VerticalPercentage,
        actualBidPoints: _.map(reversedBidPoints, point => ({
          x: new Date(i18n.formatDate(new Date(point.Date), {
            raw: 'yyyy-MM-dd',
            timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
          })),
          y: point.Actual_Conversion,
        })),
        estimatedBidPoints: _.map(reversedBidPoints, point => ({
          x: new Date(i18n.formatDate(new Date(point.Date), {
            raw: 'yyyy-MM-dd',
            timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
          })),
          y: point.Estimate_Conversion,
        })),
      };
    } else if (CheckpointKey === 'BudgetConstraint') {
      const { BudgetPoints } = CheckpointData[0];
      const reversedBudgetPoints = BudgetPoints.reverse();
      normalizedData = {
        startDate: i18n.formatDate(new Date(_.first(reversedBudgetPoints).Date), {
          skeleton: 'yMd',
          timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
        }),
        endDate: i18n.formatDate(new Date(_.last(reversedBudgetPoints).Date), {
          skeleton: 'yMd',
          timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
        }),
        missedImpressions: CheckpointData[0].MissingImpressions,
        actualBudget: CheckpointData[0].OriginalBudget,
        recommendedBudget: CheckpointData[0].RecommendedBudget,
        actualBudgetPoints: _.map(reversedBudgetPoints, point => ({
          x: new Date(i18n.formatDate(new Date(point.Date), {
            raw: 'yyyy-MM-dd',
            timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
          })),
          y: point.Impressions,
        })),
        estimatedBudgetPoints: _.map(reversedBudgetPoints, point => ({
          x: new Date(i18n.formatDate(new Date(point.Date), {
            raw: 'yyyy-MM-dd',
            timeZone: toIANATimeZone(fromLegacyTimeZone(_.get(serverContext, ['CurrentAccount', 'TimeZone']))),
          })),
          y: point.ProjectedImpressionsRecommendedBudget,
        })),
      };
    }
    result[CheckpointKey] = normalizedData;
  });
  return result;
};
